export const ADD_SUCCESS = 'Новая модель добавлена';
export const ADD_ERROR = 'Не удалось добавить модель';
